import dataLayer from './lib/gtm'
import env from './env';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store.js';
import api from './api';
import timeout from './utils/timeout';
import $loading from './store/plugins/showLoading';
import baseComponents from './components/_componentLoader';
import * as Sentry from '@sentry/browser';
import { Vue as SentryVueIntegration } from '@sentry/integrations';

// Use Sentry for error tracking & notifications in production
if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://401d5b872bad4071bde4bfc2b76b767c@o427890.ingest.sentry.io/5372685',
        integrations: [
            new SentryVueIntegration({
                Vue,
                attachProps: true,
                logErrors: true
            })
        ],
        environment: window.location.host.includes('netlify.app') ? 'QA' : 'Production'
    });
}
Vue.config.productionTip = false;
Vue.prototype.$env = env;
Vue.prototype.$api = api;
Vue.prototype.$timeout = timeout;
Vue.prototype.$dataLayer = dataLayer;
Vue.use($loading);

// Custom directive that shows/hide a tooltip on mouseenter/leave
Vue.directive('tooltip', {
    bind(el, binding, vnode) {
        const { message, position } = getTooltipData(binding.value);
        el.dataset.tooltipMsg = message;
        el.dataset.tooltipPos = position;
        el.addEventListener('mouseenter', function() {
            if (!el.dataset.tooltipMsg) return;
            vnode.context.$store.commit('tooltip/set', {
                trigger: el,
                message: el.dataset.tooltipMsg,
                position: el.dataset.tooltipPos,
            });
        });
        el.addEventListener('mouseleave', function() {
            vnode.context.$store.commit('tooltip/clear');
        });
        el.addEventListener('click', function(e) {
            e.stopPropagation();
        });
    },
    update(el, binding) {
        const newData = getTooltipData(binding.value);
        const oldData = getTooltipData(binding.oldValue);
        if (newData.message === oldData.message) return;
        el.dataset.tooltipMsg = newData.message;
        el.dataset.tooltipPos = newData.position;
    }
});

function getTooltipData(value) {
    let message, position;
    if (value && typeof value === 'object') {
        message = value.message;
        position = value.position || 'top';
    } else {
        message = value;
        position = 'top';
    }
    return { message, position };
}

baseComponents.forEach(component => Vue.component(component.name, component.config));

if (localStorage.authToken) {
    store.commit('auth/setAuthToken', localStorage.authToken);
}

let app = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');

if (store.getters['base/isDev']) {
    window.app = app;
    window.getters = app.$store.getters;
    window.commit = app.$store.commit;
    window.dispatch = app.$store.dispatch;
}